import * as yup from "yup";
import { createPasswordFieldSchema } from "./schemaUtils";

export const passwordRegex = {
    minMax: /^.{8,128}$/,
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /\d/,
    // specialChar: /[!@#^*_?{}\-]/,
};

// Used by reset password form (fields: password, confirmpassword)
export const changePasswordSchema = yup.object().shape({
  password: createPasswordFieldSchema(passwordRegex, "New Password is required"),
  confirmpassword: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

// Used by change password screen (fields: new_password, confirmPassword)
export const createPasswordSchema = yup.object().shape({
  new_password: createPasswordFieldSchema(
    passwordRegex,
    "New Password is required"
  ),
  confirmPassword: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("new_password")], "Passwords must match"),
});
